import React, { createContext, useContext, useState } from "react";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("cl_lang") || "en");
  const change = (l) => {
    setLang(l);
    localStorage.setItem("cl_lang", l);
  };
  return <LanguageContext.Provider value={{ lang, setLang: change }}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);
